import { ReactNode, createContext, useContext } from 'react'
import { useOrganizationContext, useUserContext } from '~/core/context'
import { useWordpress } from './hooks/useWordpress'

const useInternal = () => {
  const { session } = useUserContext()
  const { organizationMember } = useOrganizationContext()

  const hook = useWordpress({ organizationMember, user: session.user })

  return {
    ...hook,
  }
}

type BlogPostContext = ReturnType<typeof useInternal>

const BlogPostContext = createContext<BlogPostContext>(undefined)

export const BlogPostProvider = ({ children }: { children: ReactNode }) => {
  const value = useInternal()

  return (
    <>
      <BlogPostContext.Provider value={value}>
        {children}
      </BlogPostContext.Provider>
    </>
  )
}

export const useBlogPostContext = (): BlogPostContext => {
  const context = useContext(BlogPostContext)

  if (context === undefined) {
    throw new Error('useBlogPostContext must be used within a BlogPostProvider')
  }

  return context
}
